import { AuthProvider } from "../auth/AuthProvider";
import { AuthenticatedPageErrorBoundary, PageErrorBoundary } from "./error/ErrorPage";
import { queryClient } from "../api/queryClient";
import { Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { TranslationProvider } from "@privacy/translations";
import { LayoutWhenLoading } from "./layout/Layout";
import { PageSpinner } from "../shared/Page";
import { Outlet } from "react-router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "@privacy/ui";

export const Providers = () => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Suspense
          fallback={
            <LayoutWhenLoading>
              <PageSpinner />
            </LayoutWhenLoading>
          }
        >
          <TranslationProvider>
            <PageErrorBoundary authConfig={{ isAuthenticated: false }} includePlaceholderSidebar>
              <AuthProvider>
                <AuthenticatedPageErrorBoundary>
                  <Outlet />
                </AuthenticatedPageErrorBoundary>
                <ReactQueryDevtools buttonPosition="bottom-left" />
              </AuthProvider>
            </PageErrorBoundary>
          </TranslationProvider>
        </Suspense>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
